<script>
import GenerateForm from '@/common/src/form-making/components/Compact/GenerateForm.vue'
import Page from './Page.vue'

export default {
	extends: Page,
	components: { GenerateForm }
}
</script>
